<script>
export default {
	name: "CardBox",
	props: {
		data: {
			type: Object,
		},
	},
};
</script>

<template>
	<article class="p-2">
		<img :src="`/static/images/icons/${data.icon}-icon.svg`" :alt="`Icon ${data.icon}`" />
		<h2 class="font-semibold">{{ data.title }}</h2>
		<p>{{ data.text }}</p>
	</article>
</template>

<style lang="scss" scoped>
article {
	background-color: var(--global-color-grey-4);
	border-radius: 1rem;
	height: 100%;
	flex: 1;
}

img {
	margin-bottom: 0.5rem;
}

h2 {
	margin: 0.5rem 0;
	line-height: 1.6rem !important;
}
</style>
